// ---------------------------------------------------------------------------
// Hero Section Renderer
// ---------------------------------------------------------------------------

import { registerRenderer } from "../registry.js";
import type { RenderContext } from "../types.js";
import { attr, text, url } from "../escape.js";
import { buildHeroTransitionName } from "../view-transitions.js";

interface HeroSectionProps {
  headline: string;
  subheadline?: string;
  ctaText: string;
  ctaUrl?: string;
  backgroundImage?: string;
  backgroundOverlay?: number;
  alignment?: "left" | "center" | "right";
  minHeight?: string;
}

function render(props: Record<string, unknown>, _ctx: RenderContext): string {
  const p = props as unknown as HeroSectionProps;

  const headline = p.headline ?? "";
  const ctaText = p.ctaText ?? "Get Started";
  const ctaUrl = p.ctaUrl ?? "#form";
  const alignment = p.alignment ?? "center";
  const minHeight = p.minHeight ?? "80vh";
  const overlay = p.backgroundOverlay ?? 40;

  const bgStyle = p.backgroundImage
    ? `background-image: url('${attr(p.backgroundImage)}'); background-size: cover; background-position: center;`
    : "";

  const overlayHtml = p.backgroundImage
    ? `<div class="ease-hero-overlay" style="position: absolute; inset: 0; background: var(--ease-overlay-backdrop, rgba(15,23,42,.45)); opacity: ${attr(String(overlay / 100))};"></div>`
    : "";

  const subheadlineHtml = p.subheadline
    ? `\n    <p class="ease-hero-subheadline">${text(p.subheadline)}</p>`
    : "";
  const transitionStyle = `view-transition-name: ${attr(buildHeroTransitionName(_ctx.pageId))};`;

  return `<section class="ease-section ease-hero" aria-label="${attr(headline)}" style="position: relative; min-height: ${attr(minHeight)}; text-align: ${attr(alignment)}; display: flex; align-items: center; justify-content: center; ${bgStyle} ${transitionStyle}">
  ${overlayHtml}
  <div class="ease-hero-content" style="position: relative; z-index: 1;">
    <h1 class="ease-hero-headline">${text(headline)}</h1>${subheadlineHtml}
    <a href="${url(ctaUrl)}" class="ease-btn ease-btn-primary ease-hero-cta">${text(ctaText)}</a>
  </div>
</section>`;
}

registerRenderer("hero-section", { render });
